module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gxiwJ"))).then(() => parcelRequire('hEqeo'));